import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { data } from 'jquery';
import Swal from 'sweetalert2';
import { BaseClass, eMenu } from '../_common/base.common';
import { RolesInterface, Utilitarios } from '../_common/utilitarios.common';
import { ConfiguracaoSistemaInterface } from '../_interfaces/configuracao-sistema.interface';
import { AutenticacaoService } from '../_services/autenticacao/autenticacao.service';
import { ConfiguracaoSistemaService } from '../_services/configuracao-sistema/configuracao-sistema.service';

// Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  collapse?: string;
  icontype: string;
  // icon: string;
  children?: ChildrenItems[];
  visivel: boolean;
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab?: string;
  type?: string;
  icontype: string;
  visivel?: boolean;
}

var _menuClienteVisivel: boolean;
var _menuUsuarioVisivel: boolean;
var _menuRemetenteVisivel: boolean;
var _menuDestinatarioVisivel: boolean;
var _menuConfigEmailVisivel: boolean;

var _menuPainelVisivel: boolean;
var _menuHardwareGrupoVisivel: boolean;
var _menuMonitoracaoVisivel: boolean;
var _menuVisualizacaoVisivel: boolean;

var _menuOcorrenciaVisivel: boolean;
var _menuTipoOcorrenciaVisivel: boolean;
var _menuEventoVisivel: boolean;
var _menuTipoEventoVisivel: boolean;
var _menuOrigemVisivel: boolean;
var _menuOrigemFilhoVisivel: boolean;
var _menuGrupoVisivel: boolean;
var _menuAlarmeVisivel: boolean;
var _menuAlarmeAliasVisivel: boolean;
var _menuAgendamentoVisivel: boolean;

var _menuAuditorVisivel: boolean;
var _menuRestricaoVisivel: boolean;
var _menuModuloVisivel: boolean;

var _menuServicosVisivel: boolean;

var _menuReportConexaoVisivel: boolean;
var _menuReportGrupoVisivel: boolean;
var _menuReportVisivel: boolean;
var _menuReportMenuVisivel: boolean;
var _menuReportPerfilFiltroVisivel: boolean;
var _menuReportParametrosVisivel: boolean;

var _menuAdministrativoVisivel: boolean;

var _menuLinksCompartilhados: boolean;

// Menu Items
export const ROUTES: RouteInfo[] = [
  {
    visivel: true,
    path: '',
    title: 'Clientes',
    type: 'sub',
    icontype: 'nc-icon nc-globe',
    collapse: 'clientes',
    children:
      [
        { path: 'listar-cliente', title: 'Clientes', ab: 'CL', icontype: 'nc-icon nc-globe-2', visivel: _menuClienteVisivel },
        { path: 'listar-usuario', title: 'Usuários', ab: 'US', icontype: 'nc-icon nc-single-02', visivel: _menuUsuarioVisivel },
        { path: 'listar-remetente', title: 'Remetentes', ab: 'RE', icontype: 'nc-icon nc-email-85', visivel: _menuRemetenteVisivel },
        { path: 'listar-destinatario', title: 'Destinatário', ab: 'DE', icontype: 'nc-icon nc-circle-10', visivel: _menuDestinatarioVisivel },
        { path: 'listar-configuracao-email', title: 'Configuração E-mail', ab: 'CE', icontype: 'nc-icon nc-settings', visivel: _menuConfigEmailVisivel },
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Dashboard',
    type: 'sub',
    icontype: 'nc-icon nc-chart-pie-36',
    collapse: 'dashboard',
    children:
      [
        { path: 'listar-painel', title: 'Painel', icontype: 'nc-icon nc-layout-11', ab: 'DS', visivel: _menuPainelVisivel },
        { path: 'listar-hardware-grupo', title: 'Grupos de Computador', icontype: 'nc-icon nc-laptop', ab: 'GC', visivel: _menuHardwareGrupoVisivel },
        { path: 'listar-monitoracao', title: 'Monitoração', icontype: 'nc-icon nc-sound-wave', ab: 'MO', visivel: _menuMonitoracaoVisivel },
        { path: 'listar-visualizacao', title: 'Grupos de Visualização', icontype: 'nc-icon nc-image', ab: 'GV', visivel: _menuVisualizacaoVisivel }
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Agendamento',
    type: 'sub',
    icontype: 'nc-icon nc-bullet-list-67',
    collapse: 'agendamento',
    children:
      [
        { path: 'listar-ocorrencia', title: 'Ocorrência', icontype: 'nc-icon nc-laptop', ab: 'OC', visivel: _menuOcorrenciaVisivel },
        { path: 'listar-tipo-ocorrencia', title: 'Tipo de Ocorrência', icontype: 'nc-icon nc-ruler-pencil', ab: 'TO', visivel: _menuTipoOcorrenciaVisivel },
        { path: 'listar-evento', title: 'Eventos', icontype: 'nc-icon nc-tv-2', visivel: _menuEventoVisivel },
        { path: 'listar-tipo-evento', title: 'Tipo de Evento', icontype: 'nc-icon nc-map-big', visivel: _menuTipoEventoVisivel },
        { path: 'listar-origem', title: 'Origem', icontype: 'nc-icon nc-world-2', visivel: _menuOrigemVisivel },
        { path: 'listar-origem-filho', title: 'Origem Filho', icontype: 'nc-icon nc-pin-3', visivel: _menuOrigemFilhoVisivel },
        { path: 'listar-grupo', title: 'Grupo Destinatários', icontype: 'nc-icon nc-box', visivel: _menuGrupoVisivel },
        { path: 'listar-alarme', title: 'Alarme', icontype: 'nc-icon nc-time-alarm', visivel: _menuAlarmeVisivel },
        { path: 'listar-alarme-alias', title: 'Alarme Alias', icontype: 'nc-icon nc-paper', visivel: _menuAlarmeAliasVisivel },
        { path: 'listar-agendamento', title: 'Agendamentos', icontype: 'nc-icon nc-bullet-list-67', ab: 'AG', visivel: _menuAgendamentoVisivel },
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Parâmetros',
    type: 'sub',
    icontype: 'nc-icon nc-settings-gear-65',
    collapse: 'parametros',
    children:
      [
        { path: 'listar-auditor', title: 'Auditor', icontype: 'nc-icon nc-key-25', visivel: _menuAuditorVisivel },
        { path: 'listar-restricao', title: 'Restrição', icontype: 'nc-icon nc-simple-remove', visivel: _menuRestricaoVisivel },
        { path: 'listar-modulo', title: 'Módulos', icontype: 'nc-icon nc-app', visivel: _menuModuloVisivel },
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Serviços',
    type: 'sub',
    icontype: 'nc-icon nc-settings',
    collapse: 'servicos',
    children:
      [
        { path: 'listar-servico', title: 'Serviços', icontype: 'nc-icon nc-calendar-60', visivel: _menuServicosVisivel }
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Report',
    type: 'sub',
    icontype: 'nc-icon nc-laptop',
    collapse: 'reportMenu',
    children:
      [
        { path: 'listar-report-conexao', title: 'Conexão', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportConexaoVisivel },
        { path: 'listar-report-grupo', title: 'Grupos', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportGrupoVisivel },
        { path: 'listar-report', title: 'Criar Relatórios', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportVisivel },
        { path: 'listar-report-menu', title: 'Relatórios', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportMenuVisivel },
        { path: 'listar-report-perfil-filtro', title: 'Perfil Filtro', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportPerfilFiltroVisivel },
        { path: 'adicionar-parametros', title: 'Parâmetros', icontype: 'nc-icon nc-single-copy-04', visivel: _menuReportParametrosVisivel },
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Administrativo',
    type: 'sub',
    icontype: 'nc-icon nc-atom',
    collapse: 'administrativoMenu',
    children:
      [
        { path: 'listar-adm-perfil', title: 'Perfil', icontype: 'nc-icon nc-badge', visivel: true }
      ]
  },
  {
    visivel: false,
    path: '',
    title: 'Conciliação',
    type: 'sub',
    icontype: 'nc-icon nc-atom',
    collapse: 'conciliacaoMenu',
    children:
      [
        { path: 'listar-bandeira', title: 'Bandeira', icontype: 'nc-icon nc-badge', visivel: true },
        { path: 'listar-adquirente', title: 'Adquirente', icontype: 'nc-icon nc-badge', visivel: true },
        { path: 'listar-estabelecimento', title: 'Estabelecimento', icontype: 'nc-icon nc-badge', visivel: true },
        { path: 'listar-terminal', title: 'Terminal', icontype: 'nc-icon nc-badge', visivel: true },
        { path: 'listar-contrato', title: 'Contrato', icontype: 'nc-icon nc-badge', visivel: true },
        { path: 'listar-criterio-conciliacao', title: 'Critério Conciliação', icontype: 'nc-icon nc-badge', visivel: true },
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Indicadores',
    type: 'sub',
    icontype: 'nc-icon nc-atom',
    collapse: 'indicadoresMenu',
    children:
      [
        { path: 'listar-indicadores', title: 'Indicadores', icontype: 'nc-icon nc-badge', visivel: true }
      ]
  },
  {
    visivel: true,
    path: '',
    title: 'Links',
    type: 'sub',
    icontype: 'nc-icon nc-paper',
    collapse: 'linksCompartilhadosMenu',
    children:
      [
        { path: 'listar-links-compartilhados', title: 'Gerenciar', icontype: 'nc-icon nc-badge', visivel: true }
      ]
  }
];

@Component({
  moduleId: module.id,
  selector: 'sidebar-cmp',
  templateUrl: 'sidebar.component.html',
})

export class SidebarComponent extends BaseClass {

  public objConfigSistema: ConfiguracaoSistemaInterface;

  public menuItems: any[];
  public nmUsuario: string;
  public nmUsuarioPrimeiraLetra: string;

  constructor(
    private pRoute: Router,
    private pConfiguracaoSistemaService: ConfiguracaoSistemaService,
    private pAutenticacaoService: AutenticacaoService) {
    super();

  }

  isNotMobileMenu() {
    if (window.outerWidth > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.pConfiguracaoSistemaService.selecionarNomeSistema().then((data) => {
      this.objConfigSistema = <ConfiguracaoSistemaInterface>data;
    }, e => {
      let _err = <HttpErrorResponse>e;

      Swal.fire("Erro!", `${_err.message}`, "error");
    });

    let _objUtilitarios = new Utilitarios();

    let _objUsuarioLogado = _objUtilitarios.RetornarLocalStorageAutenticacao();

    if (_objUsuarioLogado != undefined || _objUsuarioLogado != null) {
      if (_objUsuarioLogado.dsNome !== "god") {
        this.pAutenticacaoService.selecionarRolesUsuario(_objUsuarioLogado.id).then((data) => {
          let _roles = <RolesInterface[]>data;

          for (var i = 0; i < _roles.length; i++) {
            let _obj = _roles[i];

            Utilitarios.Roles.push({
              acao: _obj.acao,
              rota: _obj.rota
            });
          }
        });
      }
      else {
        Utilitarios.IsAdmin = true;
      }
    }
    else {
      let publicRoutes = ['/visualizar-links-compartilhados', '/visualizar-resultados-compartilhados'];

      if (publicRoutes.some(route => this.pRoute.url.startsWith(route))) {
        return;
      }

      this.pRoute.navigate(['/pages/login']);
    }

    this.VerificarPermissao(eMenu.TodosMenus);

    _menuClienteVisivel = this.SetMenuClienteVisivel() || Utilitarios.IsAdmin;
    _menuUsuarioVisivel = this.SetMenuUsuarioVisivel() || Utilitarios.IsAdmin;
    _menuRemetenteVisivel = this.SetMenuRemetenteVisivel() || Utilitarios.IsAdmin;
    _menuDestinatarioVisivel = this.SetMenuDestinatarioVisivel() || Utilitarios.IsAdmin;
    _menuConfigEmailVisivel = this.SetMenuConfigEmailVisivel() || Utilitarios.IsAdmin;

    _menuPainelVisivel = this.SetMenuPainelVisivel() || Utilitarios.IsAdmin;
    _menuHardwareGrupoVisivel = this.SetMenuHardwareGrupoVisivel() || Utilitarios.IsAdmin;
    _menuMonitoracaoVisivel = this.SetMenuMonitoracaoVisivel() || Utilitarios.IsAdmin;
    _menuVisualizacaoVisivel = this.SetMenuVisualizacaoVisivel() || Utilitarios.IsAdmin;

    _menuOcorrenciaVisivel = this.SetMenuOcorrenciaVisivel() || Utilitarios.IsAdmin;
    _menuTipoOcorrenciaVisivel = this.SetMenuTipoOcorrenciaVisivel() || Utilitarios.IsAdmin;
    _menuEventoVisivel = this.SetMenuEventoVisivel() || Utilitarios.IsAdmin;
    _menuTipoEventoVisivel = this.SetMenuTipoEventoVisivel() || Utilitarios.IsAdmin;
    _menuOrigemVisivel = this.SetMenuOrigemVisivel() || Utilitarios.IsAdmin;
    _menuOrigemFilhoVisivel = this.SetMenuOrigemFilhoVisivel() || Utilitarios.IsAdmin;
    _menuGrupoVisivel = this.SetMenuGrupoVisivel() || Utilitarios.IsAdmin;
    _menuAlarmeVisivel = this.SetMenuAlarmeVisivel() || Utilitarios.IsAdmin;
    _menuAlarmeAliasVisivel = this.SetMenuAlarmeAliasVisivel() || Utilitarios.IsAdmin;
    _menuAgendamentoVisivel = this.SetMenuAgendamentoVisivel() || Utilitarios.IsAdmin;

    _menuAuditorVisivel = this.SetMenuAuditorVisivel() || Utilitarios.IsAdmin;
    _menuRestricaoVisivel = this.SetMenuRestricaoVisivel() || Utilitarios.IsAdmin;
    _menuModuloVisivel = this.SetMenuModuloVisivel() || Utilitarios.IsAdmin;

    _menuServicosVisivel = this.SetMenuServicosVisivel() || Utilitarios.IsAdmin;

    _menuReportConexaoVisivel = this.SetMenuReportConexaoVisivel() || Utilitarios.IsAdmin;
    _menuReportGrupoVisivel = this.SetMenuReportGrupoVisivel() || Utilitarios.IsAdmin;
    _menuReportVisivel = this.SetMenuReportVisivel() || Utilitarios.IsAdmin;
    _menuReportMenuVisivel = this.SetMenuReportMenuVisivel() || Utilitarios.IsAdmin;
    _menuReportPerfilFiltroVisivel = Utilitarios.IsAdmin; //this.SetMenuReportPerfilFiltroVisivel() || Utilitarios.IsAdmin;
    _menuReportParametrosVisivel = true; //this.SetMenuReportPerfilFiltroVisivel() || Utilitarios.IsAdmin;

    _menuAdministrativoVisivel = Utilitarios.IsAdmin;

    _menuLinksCompartilhados = this.SetMenuLinksCompartilhados() || Utilitarios.IsAdmin;

    for (var i = 0; i < ROUTES.length; i++) {
      let _obj = ROUTES[i];

      if (_obj.title === "Clientes") {
        _obj.visivel = _menuClienteVisivel || _menuUsuarioVisivel || _menuRemetenteVisivel || _menuDestinatarioVisivel || _menuConfigEmailVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-cliente") {
            _objFilho.visivel = _menuClienteVisivel;
          }
          else if (_objFilho.path === "listar-usuario") {
            _objFilho.visivel = _menuUsuarioVisivel;
          }
          else if (_objFilho.path === "listar-remetente") {
            _objFilho.visivel = _menuRemetenteVisivel;
          }
          else if (_objFilho.path === "listar-destinatario") {
            _objFilho.visivel = _menuDestinatarioVisivel;
          }
          else if (_objFilho.path === "listar-configuracao-email") {
            _objFilho.visivel = _menuConfigEmailVisivel;
          }
        }
      }
      else if (_obj.title === "Dashboard") {
        _obj.visivel = _menuPainelVisivel || _menuHardwareGrupoVisivel || _menuMonitoracaoVisivel || _menuVisualizacaoVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-painel") {
            _objFilho.visivel = _menuPainelVisivel;
          }
          else if (_objFilho.path === "listar-hardware-grupo") {
            _objFilho.visivel = _menuHardwareGrupoVisivel;
          }
          else if (_objFilho.path === "listar-monitoracao") {
            _objFilho.visivel = _menuMonitoracaoVisivel;
          }
          else if (_objFilho.path === "listar-visualizacao") {
            _objFilho.visivel = _menuVisualizacaoVisivel;
          }
        }
      }
      else if (_obj.title === "Agendamento") {
        _obj.visivel =
          _menuOcorrenciaVisivel || _menuTipoOcorrenciaVisivel || _menuEventoVisivel || _menuTipoEventoVisivel || _menuOrigemVisivel ||
          _menuOrigemFilhoVisivel || _menuGrupoVisivel || _menuAlarmeVisivel || _menuAlarmeAliasVisivel || _menuAgendamentoVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-ocorrencia") {
            _objFilho.visivel = _menuOcorrenciaVisivel;
          }
          else if (_objFilho.path === "listar-tipo-ocorrencia") {
            _objFilho.visivel = _menuTipoOcorrenciaVisivel;
          }
          else if (_objFilho.path === "listar-evento") {
            _objFilho.visivel = _menuEventoVisivel;
          }
          else if (_objFilho.path === "listar-tipo-evento") {
            _objFilho.visivel = _menuTipoEventoVisivel;
          }
          else if (_objFilho.path === "listar-origem") {
            _objFilho.visivel = _menuOrigemVisivel;
          }
          else if (_objFilho.path === "listar-origem-filho") {
            _objFilho.visivel = _menuOrigemFilhoVisivel;
          }
          else if (_objFilho.path === "listar-grupo") {
            _objFilho.visivel = _menuGrupoVisivel;
          }
          else if (_objFilho.path === "listar-alarme") {
            _objFilho.visivel = _menuAlarmeVisivel;
          }
          else if (_objFilho.path === "listar-alarme-alias") {
            _objFilho.visivel = _menuAlarmeAliasVisivel;
          }
          else if (_objFilho.path === "listar-agendamento") {
            _objFilho.visivel = _menuAgendamentoVisivel;
          }
        }
      }
      else if (_obj.title === "Parâmetros") {
        _obj.visivel = _menuAuditorVisivel || _menuRestricaoVisivel || _menuModuloVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-auditor") {
            _objFilho.visivel = _menuAuditorVisivel;
          }
          else if (_objFilho.path === "listar-restricao") {
            _objFilho.visivel = _menuRestricaoVisivel;
          }
          else if (_objFilho.path === "listar-modulo") {
            _objFilho.visivel = _menuModuloVisivel;
          }
        }
      }
      else if (_obj.title === "Serviços") {
        _obj.visivel = _menuServicosVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-servico") {
            _objFilho.visivel = _menuServicosVisivel;
          }
        }
      }
      else if (_obj.title === "Report") {
        _obj.visivel = _menuReportConexaoVisivel || _menuReportGrupoVisivel || _menuReportVisivel ||
          _menuReportMenuVisivel || _menuReportPerfilFiltroVisivel || _menuReportParametrosVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-report-conexao") {
            _objFilho.visivel = _menuReportConexaoVisivel;
          }
          else if (_objFilho.path === "listar-report-grupo") {
            _objFilho.visivel = _menuReportGrupoVisivel;
          }
          else if (_objFilho.path === "listar-report") {
            _objFilho.visivel = _menuReportVisivel;
          }
          else if (_objFilho.path === "listar-report-menu") {
            _objFilho.visivel = _menuReportMenuVisivel;
          }
          else if (_objFilho.path === "listar-report-perfil-filtro") {
            _objFilho.visivel = _menuReportPerfilFiltroVisivel;
          }
          else if (_objFilho.path === "adicionar-parametros") {
            _objFilho.visivel = _menuReportParametrosVisivel;
          }
        }
      }
      else if (_obj.title === "Administrativo") {
        _obj.visivel = _menuAdministrativoVisivel;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-adm-perfil") {
            _objFilho.visivel = true;
          }
        }
      }
      else if (_obj.title === "Links Compartilhados") {
        _obj.visivel = _menuLinksCompartilhados;

        for (var j = 0; j < _obj.children.length; j++) {
          let _objFilho = _obj.children[j];

          if (_objFilho.path === "listar-links-compartilhados") {
            _objFilho.visivel = true;
          }
        }
      }
    }

    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.SetNomeUsuario();
  }

  ngAfterViewInit() {
  }

  private SetNomeUsuario() {
    var _obj = new Utilitarios().RetornarLocalStorageAutenticacao();

    if (_obj != undefined || _obj != null) {
      if (_obj.dsNome === "god") {
        _obj.dsNome = "ADMIN";
      }

      this.nmUsuario = _obj.dsNome;
      this.nmUsuarioPrimeiraLetra = this.nmUsuario.substring(0, 1);
    }
  }

  SetMenuClienteVisivel(): boolean {
    return this.roleListarCliente || this.roleAdicionarCliente || this.roleEditarCliente || this.roleDetalheCliente || this.roleContatoCliente || this.roleAtivarDesativarCliente;
  }

  SetMenuUsuarioVisivel(): boolean {
    return this.roleAdicionarUsuario || this.roleEditarUsuario || this.roleListarUsuario || this.roleVisualizarUsuario;
  }

  SetMenuRemetenteVisivel(): boolean {
    return this.roleListarRemetente || this.roleAdicionarRemetente || this.roleEditarRemetente || this.roleAtivarDesativarRemetente;
  }

  SetMenuDestinatarioVisivel(): boolean {
    return this.roleListarDestinatarios || this.roleAdicionarDestinatario || this.roleEditarDestinatario || this.roleAtivarDesativarDestinatario;
  }

  SetMenuConfigEmailVisivel(): boolean {
    return this.roleListarConfigEmail || this.roleAdicionarConfigEmail || this.roleEditarConfigEmail || this.roleAtivarDesativarConfigEmail;
  }

  SetMenuPainelVisivel(): boolean {
    return this.roleListarPainel || this.roleAdicionarPainel || this.roleEditarPainel || this.roleListarWidget || this.roleAdicionarWidget;
  }

  SetMenuHardwareGrupoVisivel(): boolean {
    return this.roleListarHardwareGrupo || this.roleAdicionarHardwareGrupo || this.roleEditarHardwareGrupo;
  }

  SetMenuMonitoracaoVisivel(): boolean {
    return this.roleListarMonitoracao || this.roleVisualizarComputadores || this.roleVisualizarMonitoracao || this.roleInserirGrupo || this.roleEditarAlias;
  }

  SetMenuVisualizacaoVisivel(): boolean {
    return this.roleListarVisualizacao || this.roleAdicionarVisualizacao || this.roleEditarVisualizacao || this.roleVisualizarGrupoItem;
  }

  SetMenuOcorrenciaVisivel(): boolean {
    return this.roleListarOcorrencia || this.roleAdicionarOcorrencia || this.roleEditarOcorrencia;
  }

  SetMenuTipoOcorrenciaVisivel(): boolean {
    return this.roleListarTipoOcorrencia || this.roleAdicionarTipoOcorrencia || this.roleEditarTipoOcorrencia;
  }

  SetMenuEventoVisivel(): boolean {
    return this.roleAdicionarEvento || this.roleListarEvento || this.roleEditarEvento;
  }

  SetMenuTipoEventoVisivel(): boolean {
    return this.roleListarTipoEvento || this.roleAdicionarTipoEvento || this.roleEditarTipoEvento;
  }

  SetMenuOrigemVisivel(): boolean {
    return this.roleListarOrigem || this.roleAdicionarOrigem || this.roleEditarOrigem;
  }

  SetMenuOrigemFilhoVisivel(): boolean {
    return this.roleListarOrigemFilho || this.roleAdicionarOrigemFilho || this.roleEditarOrigemFilho;
  }

  SetMenuGrupoVisivel(): boolean {
    return this.roleListarGrupo || this.roleAdicionarGrupo || this.roleEditarGrupo || this.roleAdicionarGrupoDestinatario || this.roleVisualizarGrupoDestinatario;
  }

  SetMenuAlarmeVisivel(): boolean {
    return this.roleListarAlarme || this.roleAdicionarAlarme || this.roleEditarAlarme;
  }

  SetMenuAlarmeAliasVisivel(): boolean {
    return this.roleListarAlarmeAlias || this.roleAdicionarAlarmeAlias || this.roleEditarAlarmeAlias;
  }

  SetMenuAgendamentoVisivel(): boolean {
    return this.roleListarAgendamento || this.roleAdicionarAgendamento || this.roleEditarAgendamento || this.roleAtivarDesativarAgendamento;
  }

  SetMenuAuditorVisivel(): boolean {
    return this.roleAdicionarAuditor || this.roleEditarAuditor || this.roleListarAuditor;
  }

  SetMenuRestricaoVisivel(): boolean {
    return this.roleAdicionarRestricao || this.roleEditarRestricao || this.roleListarRestricao;
  }

  SetMenuModuloVisivel(): boolean {
    return this.roleAdicionarModulo || this.roleEditarModulo || this.roleListarModulo;
  }

  SetMenuServicosVisivel(): boolean {
    return this.roleListarServico;
  }

  SetMenuReportConexaoVisivel(): boolean {
    return this.roleListarReportConexao || this.roleAdicionarReportConexao || this.roleEditarReportConexao || this.roleAtivarDesativarReportConexao;
  }

  SetMenuReportGrupoVisivel(): boolean {
    return this.roleListarReportGrupo || this.roleAdicionarReportGrupo || this.roleEditarReportGrupo || this.roleAtivarDesativarReportGrupo;
  }

  SetMenuReportVisivel(): boolean {
    return this.roleAdicionarReport || this.roleListarReport || this.roleEditarReport || this.roleAdicionarReportQuery || this.roleAtivarDesativarReport;
  }

  SetMenuReportMenuVisivel(): boolean {
    return this.roleListarReportMenu || this.roleVisualizarReportResultado || this.roleSalvarReport || this.roleVisualizarReportSalvo || this.roleInserirRemoverCampos || this.roleReportFilho || this.roleExportarResultado;
  }

  SetMenuReportPerfilFiltroVisivel(): boolean {
    return this.roleListarReportMenu || this.roleVisualizarReportResultado || this.roleAdicionarCamposParametrizaveis || this.roleEditarReportPerfilFiltro || this.roleAdicionarCamposParametrizaveisReportPerfilFiltro;
  }

  SetMenuLinksCompartilhados(): boolean {
    return this.roleListarLinksCompartilhados;
  }
}
